<template>
    <div>
        <delete-confirmation name="payment" @confirm="deletePayment"></delete-confirmation>
        <div class="d-flex justify-content-between">
            <div class="h5 font-weight-bold">
                Payments
            </div>
            <div v-if="userAppliedPayments">
                <button class="btn btn-sm btn-primary mb-1" title="Apply Payment" @click="togglePaymentInputs()">
                    <i class="fas fa-money-check-alt fa-lg fa-fw"></i>
                </button>
            </div>
        </div>
        <div v-if="userAppliedPayments && paymentInputsVisible" class="form-row py-2 border-top">
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <span class="input-group-text fas fa-calendar fa-lg"></span>
                    </div>                                     
                    <input id="payment_date" type="date" class="form-control form-control-sm" v-model="payment.date">               
                </div>
            </div>
            <div class="col-auto">
                <input type="text" class="form-control form-control-sm" v-model="payment.proc_code" placeholder="CPT/HCPCS">
            </div>
            <div class="col-auto">            
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                    </div>
                    <input id="amount" type="text" class="form-control form-control-sm text-right" v-model="payment.amount">
                </div>
            </div>
            <div v-if="userAppliedPayments" class="col-auto">
                <button type="button" class="btn btn-primary btn-sm" @click="applyPayment()">Apply</button>                                                
            </div>
        </div>                                                                  
        <table class="table table-striped table-sm">
            <thead>                                      
                <tr>
                    <th class="shrink">Line #</th>
                    <th>Payment Date</th>
                    <th>CPT/HCPCS</th>
                    <th class="text-right">Amount</th>
                    <th class="text-right">% of Est.</th>
                    <th>Applied Date</th>
                    <th v-if="userAppliedPayments">Applied By</th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="payments.length">
                <tr v-for="payment in payments" :key="'service-payments-' + payment.id">
                    <td>{{ payment.line_number ? payment.line_number : '' }}</td>
                    <td>{{ payment.payment_date }}</td>                                            
                    <td>{{ payment.proc_code || '' }}</td>
                    <td class="text-right">{{ payment.amount | currency }}</td>
                    <td class="text-right">{{ payment.percent_of_estimate }}%</td>
                    <td>{{ payment.created_at | localizeTime('YYYY-MM-DD') }}</td>
                    <td v-if="userAppliedPayments">{{ payment.user ? payment.user.last_name : '' }}</td>
                    <td class="shrink p-0">
                        <div class="d-flex flex-nowrap justify-content-end align-items-start">

                            <!-- delete payment -->
                            <div v-if="payment.can_delete" class="mx-1">
                                <button class="btn btn-link no-padding" title="Delete Payment" @click="confirmDelete(payment)">
                                    <i class="fas fa-trash-alt fa-md"></i>
                                </button>
                            </div>

                        </div>
                    </td>
                </tr>                                       
                <tr>
                    <td class="font-weight-bold text-right" :colspan="3"></td>
                    <td class="font-weight-bold text-right"><span class="mr-3">Total:</span>{{ total | currency }}</td>
                    <td :colspan="userAppliedPayments ? 4 : 3"></td>
                </tr>
            </tbody>
            <tfoot>
                <tr v-if="!payments.length"><td class="text-muted text-center pt-1" :colspan="colspan"><h4>No Payments</h4></td></tr>
                <tr><td :colspan="colspan"></td></tr>              
            </tfoot>
        </table>        
    </div>    
</template>

<script>
import { DocumentType } from '../../constants.js';

export default {
    props: {
        clientId: Number,
        claimId: Number,
        serviceFormId: Number,
        payments: Array,
        userAppliedPayments: Boolean,
        historical: Boolean
    },
    data() {
        return {
            paymentInputsVisible: false,
            payment: {
                date: null,
                proc_code: null,
                amount: null
            },

            DocumentType: DocumentType
        }
    },    
    computed: {
        total: function () {
            return this.payments.reduce((a, b) => a + parseFloat(b.amount), 0);
        },
        colspan: function () {
            return this.userAppliedPayments ? 8 : 7;
        }
    },
    methods: {
        togglePaymentInputs: function () {
            this.paymentInputsVisible = !this.paymentInputsVisible;
        },      
        applyPayment: function () {

            // for now, only allow payments to be applied if it has not been financed
            if (this.userAppliedPayments) {

                let url = this.historical ? 
                    `/ajax/clients/${this.clientId}/claims/${this.claimId}/historical/services/${this.serviceFormId}/payments` :
                    `/ajax/provider/service-forms/${this.serviceFormId}/payments`;

                axios.post(url, {
                    'payment': this.payment
                }).then(response => {

                    this.payment = {
                        date: null,
                        proc_code: null,
                        amount: null
                    };                

                }).catch(error => {
                    let message = 'Unable to apply payment. Please contact support.';
                    toastr['error'](message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });
            }
        },
        addPayment: function (payment) {

            if (payment.service_form_id === this.serviceFormId) {
                this.payments.push(payment);
            }
        },
        confirmDelete: function (payment) {
            eventHub.$emit('show-delete-payment-confirmation', payment.id);
        },
        deletePayment: function (paymentId) {

            if (this.historical) {

                let url = `/ajax/clients/${this.clientId}/claims/${this.claimId}/historical/services/${this.serviceFormId}/payments/${paymentId}`;
                axios.delete(url)
                    .then(response => {})
                    .catch(error => {});
            }
        }     
    },
    created() {
        eventHub.$on('add-payment', this.addPayment);
    },
    beforeDestroy() {
        eventHub.$off('add-payment');
    }    
}
</script>

<style scoped>
    tr > td {
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 1rem;
        padding-right: 1rem;
        margin: 0; 
        white-space: nowrap;      
    }

    tr > th {
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 1rem;
        padding-right: 1rem;
        margin: 0;
        white-space: nowrap;       
    }

    .no-padding {
        padding: 0 !important;
        line-height: 1;
        vertical-align: middle !important;
    }

    .shrink {
        width: 1%;
    }    
</style>